import { Component, OnInit, ViewChild, ElementRef, HostListener } from '@angular/core';
import { MessagesService } from '../messages/messages.service';
import { RunplanOnholdprojectService } from './runplan-onholdproject.service';
import { ErrorHandler } from '../utils/error-handler';
import { Paginator } from 'primeng/paginator';
import { LibStatusDTO } from './projectlib-detailsDTO';
import { RunOnHoldProjectReleaseDTO } from './run-onhold_releaseDTO';
import { MasterDataService } from '../masterdata/masterdata.service';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-runplan-onholdproject',
  templateUrl: './runplan-onholdproject.component.html',
  styleUrls: ['./runplan-onholdproject.component.css']
})
export class RunplanOnholdprojectComponent implements OnInit {

  scrollableCols: any[];
  projectListVals: any[];
  getdetailsOfLibraryOfProject: any[];
  scrollableColsforLibraryPopup: any[];
  projectPopup: boolean = false;
  blocked: boolean = false;
  @ViewChild('pp',{static : true}) paginator: Paginator;
  @ViewChild('ppforlibs',{static : true}) paginatorForLibs: Paginator;
  @ViewChild('topDiv',{static : true}) elementView: ElementRef;
  selectedLabId: string;
  errorHandler: ErrorHandler = new ErrorHandler;
  puid: string;
  totalRecords: number;
  totalRecordsForLib: number;
  projectNameDialogDisplay: any;
  divHeight: number;
  scrollHeight: string;
  projectLibMap = new Map<string, any[]>();
  projectLibIdMap = new Map<string, string[]>();
  libStatusMap = new Map<string, LibStatusDTO>();
  statusObj: LibStatusDTO;
  setProjectNameForRelease: any[] = [];
  releaseFlaggedpopup: boolean = false;
  constraintTypeOptions: any[] = [];
  selectedConstraintType: string;
  enteredConstraintId: string;
  showinputOnLoad: boolean = true;
  productIdsOptions: any[] = [];
  erroMessageAfterUpdateFailed = '';
  truncateStr ='. . .';
  loading: boolean

  constructor(private runplanOnholdprojectService: RunplanOnholdprojectService, private _messagesService: MessagesService,
    private masterdataService: MasterDataService, private confirmationService: ConfirmationService) { }

  ngOnInit() {
    this.selectedLabId = JSON.parse(localStorage.getItem('lab')).lab._id;
    this.puid = localStorage.getItem('PUID');
    this.scrollableCols = [
      { 'header': 'Project', 'field': 'projectName', 'selected': false },
      { 'header': 'Details', 'field': 'projectDescription', 'selected': false },
      { 'header': 'Customer', 'field': 'customer', 'selected': false },
      { 'header': 'No. of registered libs [total (plannable | standby | canceled | planned)]', 'field': 'noOflibs', 'selected': false },
      { 'header': '', 'field': 'checkbox', 'selected': false }
    ]
    this.refreshTheReleaseList();// Method to get the list of onHold data from project collections

    this.scrollableColsforLibraryPopup = [
      { 'header': 'Library Id', 'field': 'libraryId', 'selected': false },
      { 'header': 'Sample Name', 'field': 'sampleName', 'selected': false },
      { 'header': 'Status', 'field': 'status', 'selected': false }
    ]
    this.constraintTypeOptions = [
      { 'label': 'Independent', 'value': 'independent' },
      { 'label': 'Product', 'value': 'product' },
      { 'label': 'Batch-wise', 'value': 'batch' },
      { 'label': 'Exclusive', 'value': 'exclusive' }
    ];
  }
  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    if (this.elementView != undefined) {
      this.scrollHeight = document.documentElement.clientHeight - this.elementView.nativeElement.offsetHeight - document.getElementById("header").offsetHeight - 200 + 'px';
      this.divHeight = window.innerHeight - this.elementView.nativeElement.offsetHeight - document.getElementById("header").offsetHeight - 200;
    }
  }
  getListOfOnHoldDetails() {
    this.paginator.first = 0;
    this.projectListVals = [];
    this.blocked = true;
    this.runplanOnholdprojectService.getListOfOnholdProject(this.selectedLabId).subscribe(
      result => {
        this.blocked = false;
        if (result.data) {
          this.projectListVals = result.data.dataForProject;
          this.projectLibMap = result.data.dataForLib ? new Map(Object.entries(result.data.dataForLib.projectLibMap)):null;
          this.projectLibIdMap = result.data.dataForLib ? new Map(Object.entries(result.data.dataForLib.projectLibIdMap)):null;
          this.libStatusMap = result.data.dataForStatus ? new Map(Object.entries(result.data.dataForStatus.libMap)):null;
          this.totalRecords=result.data.projectTotal[0]?result.data.projectTotal[0].total:0;
        }
      },
      error => {
        this.handleError(error);
      });
  }

  getNooflibsFromMap(projectName: string) {
    let totalLib = 0;
    let plannedLib = 0;
    let cancelledLib = 0;
    let standbyLib = 0;
    let plannableLib = 0;

    if (this.projectLibMap && this.projectLibMap.get(projectName)) {
      totalLib = this.projectLibMap.get(projectName).length;
      this.statusObj = this.libStatusMap?this.libStatusMap.get(projectName):null;
      if(this.statusObj){
        plannedLib=this.statusObj.planned;
        cancelledLib=this.statusObj.canceled;
        standbyLib=this.statusObj.standby;
        plannableLib=this.statusObj.plannable;
      }
      return totalLib+" ("+plannableLib+"|"+standbyLib+"|"+cancelledLib+"|"+plannedLib+")";
    }else{
      return totalLib+" ("+plannableLib+"|"+standbyLib+"|"+cancelledLib+"|"+plannedLib+")";
    }
  }

  private handleError(error: any) {
    this.blocked = false;
    let message = this.errorHandler.handleError(error);
    this._messagesService.addErrorMessage(message);
  }

  getLibraryDialogBox(value: any, event: any) {
    this.paginatorForLibs.first = 0;
    this.projectPopup = true;
    this.projectNameDialogDisplay = value['projectName'];
    this.getdetailsOfLibrary();
  }

  getdetailsOfLibrary() {
    this.getdetailsOfLibraryOfProject = [];
    this.getdetailsOfLibraryOfProject = this.projectLibMap.get(this.projectNameDialogDisplay);
    this.getdetailsOfLibraryOfProject.sort((d1, d2) => {
      if (d1.libraryId < d2.libraryId)
        return -1;
      else if (d1.libraryId > d2.libraryId)
        return 1;
      else
        return 0;
    });
  }
  getDataForReleasingProject(event: any, rowData: any) {
    if (event.target.checked) {
      this.setProjectNameForRelease.push(rowData['projectName']);
    } else {
      let index = this.setProjectNameForRelease.findIndex(x => x === rowData['projectName']);
      if (index != -1) {
        this.setProjectNameForRelease.splice(index, 1);
      }
    }
  }
  releaseProject() {
    this.selectedConstraintType = '';
    this.enteredConstraintId = '';
    //This is called here instead of ngOnInit as we dont need to refesh the page every time there is a change in MDM.
    this.getListOfProductsIdFromMDM();
    this.showinputOnLoad = true;
    this.erroMessageAfterUpdateFailed = '';
    this.releaseFlaggedpopup = true;
    if (this.setProjectNameForRelease.length > 0) {
      this.setProjectNameForRelease.sort((d1, d2) => {
        if (d1 < d2)
          return -1;
        else if (d1 > d2)
          return 1;
        else
          return 0;
      });
    }
  }
  checkProjectNameInlist(rowData: any) {
    if (this.setProjectNameForRelease.includes(rowData['projectName'])) {
      return true;
    }
    return false;
  }
  checkValueForconstraintID(value: any) {
    this.enteredConstraintId = '';
    if (value === 'product') {
      this.showinputOnLoad = false;
    } else {
      this.showinputOnLoad = true;
    }
  }
  istextDisabled() {
    if (this.selectedConstraintType === 'batch' || this.selectedConstraintType === 'exclusive') {
      return false;
    } else if (this.selectedConstraintType === 'independent') {
      this.enteredConstraintId = '';
      return true;
    } else {
      return true;
    }
  }
  getListOfProductsIdFromMDM() {
    this.productIdsOptions = []
    this.blocked = true;
    this.masterdataService.getProductIdsFromMDM(this.selectedLabId).subscribe(
      result => {
        if (result.data) {
          result.data.forEach(productId => {
            this.productIdsOptions.push({ label: productId, value: productId });
          });
          this.productIdsOptions.sort((d1, d2) => {
            if (d1.value < d2.value)
              return -1;
            else if (d1.value > d2.value)
              return 1;
            else
              return 0;
          });
        }
        this.blocked = false;
      },
      error => {
        this.handleError(error);
      });
  }
  submitProjectDetails() {
    let releaseFlaggedObj: RunOnHoldProjectReleaseDTO = new RunOnHoldProjectReleaseDTO();
    releaseFlaggedObj.labId = this.selectedLabId;
    releaseFlaggedObj.listofProjectName = this.setProjectNameForRelease;
    releaseFlaggedObj.constraintType = this.selectedConstraintType;
    releaseFlaggedObj.constraintId = this.enteredConstraintId;
    releaseFlaggedObj.submitConfirmed = false;
    let libraryIds = [];
    let count=0;
    this.setProjectNameForRelease.forEach(projectName => {
      count=count+this.checkForLibsLength(projectName);
      libraryIds = libraryIds.concat(this.projectLibIdMap.get(projectName))
    });
    releaseFlaggedObj.libraryIds = libraryIds;
    releaseFlaggedObj.totalLibs = count;
    
    this.setProjectReleaseFlaggedSubscription(releaseFlaggedObj);
  }
  private setProjectReleaseFlaggedSubscription(releaseFlaggedObj: RunOnHoldProjectReleaseDTO) {
    this.blocked = true;
    this.runplanOnholdprojectService.setprojectReleaseFlagged(releaseFlaggedObj).subscribe(
      result => {
        if (result.data.includes('tagConflicts')) {
          let message = this.createTagConflictMessage(JSON.parse(result.data));
          this.blocked = false;
          this.erroMessageAfterUpdateFailed = message;
        } else if(result.data.includes('tagLengths')){
          this.blocked = false;
          this.confirmationService.confirm({
            message: 'Attention, some libraries of the selected project(s) have tags of different tag length and will not be sequenced together as planned. Are you sure you want to proceed?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
              releaseFlaggedObj.submitConfirmed = true;
              this.setProjectReleaseFlaggedSubscription(releaseFlaggedObj);
            },
            reject: () => {}
          });
        } else {
          if (result.data === 'All the projects released successfully') {
            this._messagesService.addSuccessMessage({
              severity: 'success', summary: result.data,
              detail: '',
            });
          } else {
            this._messagesService.addSuccessMessage({
              severity: 'warn', summary: result.data,
              detail: '',
            });
          }
          this.releaseFlaggedpopup = false;
          this.checkForRegisteredLibs(this.setProjectNameForRelease);
          this.getListOfOnHoldDetails();
          this.setProjectNameForRelease = [];
          this.blocked = false;
        }
      },
      error => {
        this.handleError(error);
      });
  }

  checkForRegisteredLibs(listofProjectName: any) {
    let projectNamelist = [];
    listofProjectName.forEach(projectName => {
      if (this.checkForLibsLength(projectName) === 0) {
        projectNamelist.push(projectName);
      }
    });
    if (projectNamelist.length > 0) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Project with no libraries', detail: 'There is no libraires associated with project : ' + projectNamelist });
    }
  }
  checkForLibsLength(projectName: string) {
    if (this.projectLibMap && this.projectLibMap.get(projectName)) {
      return this.projectLibMap.get(projectName).length;
    } else {
      return 0;
    }
  }
  refreshTheReleaseList() {
    this.setProjectNameForRelease = [];
    this.getListOfOnHoldDetails();
  }

  customSort(event: any) {
    let compResult = null;
    if(event.field == 'noOflibs') {
        event.data.sort((projectName1: any, projectName2: any) => {
           let project1 =this.projectLibMap && this.projectLibMap.get(projectName1.projectName) ? this.projectLibMap.get(projectName1.projectName).length : 0;
           let project2 =this.projectLibMap && this.projectLibMap.get(projectName2.projectName) ? this.projectLibMap.get(projectName2.projectName).length : 0;
           compResult = this.getSortResult(project1, project2);
            return (event.order * compResult);
        });
    }else{
      this.customSortExtended(event);
    }
  }

  customSortExtended(event:any) {
    let compResult = null;
    event.data.sort((eventData1: any, eventData2: any) => {
      let eventVal1 = eventData1[event.field] ? eventData1[event.field] : null;
      let eventVal2 = eventData2[event.field] ? eventData2[event.field] : null;
      compResult = this.getSortResult(eventVal1, eventVal2);
      return (event.order * compResult);
    });
  }

  getSortResult(value1, value2){
    if(value1 < value2){
        return -1;
    }
    return (value1 > value2) ? 1 : 0;
  }

  submitDisabledIf(){
    if (this.enteredConstraintId && this.selectedConstraintType) {
      return false;
    } else if (this.selectedConstraintType === 'independent' && this.enteredConstraintId == '') {
      return false;
    } else {
      return true;
    }
  }
  createTagConflictMessage(data: any) {
    let tagConflictMap = new Map(Object.entries(data['tagConflicts']))
    let message = 'Update is failed due to <b>' + tagConflictMap.size + '</b> tag conflicts between libraries:<br>';
    if(tagConflictMap.size > 11){
      let i: number = 1;

      for(let entry of Array.from(tagConflictMap.entries())){
        let key = entry[0];
        let value = entry[1];
        if( i == 11){
          message += this.truncateStr + '<br/>';
          message += key + '(Libs: <b>' + this.getCommaSeperatedLibraryIds(value) + '</b>)';
          break;
        }
        message +=  key + '(Libs: <b>' + this.getCommaSeperatedLibraryIds(value) + '</b>)<br/>'
        i++;
      }
    } else{
      tagConflictMap.forEach((value: string[], key: string) => {
        message += key + '(Libs: <b>' + this.getCommaSeperatedLibraryIds(value) + '</b>)<br/>'
      })
    }
    return message;
  }

  getCommaSeperatedLibraryIds(value: any) {
    let commaSeperatedLibs = '';
    value.forEach(libId =>{
      commaSeperatedLibs += libId + ', ';
    })
    return commaSeperatedLibs.substring(0, commaSeperatedLibs.length - 2);
  }
}
